import { TranslationKeys } from '~/common/types';

/**
 * Mirrors the legacy discount type integers carried by the pricing API,
 * see Shared\Enum\DiscountType on the back end.
 */
export const DISCOUNT_TYPE = {
  NONE: 0,
  BF: 1,
  PERCENTAGE: 2,
  FIXED: 3,
  POLICY_VALUE: 10,
  CG1: 12,
} as const;

export const DISCOUNT_TYPE_TRANSLATIONS: Record<number, keyof TranslationKeys> =
  {
    [DISCOUNT_TYPE.NONE]: 'app.distribution.pricing_policy.discount_type.none',
    [DISCOUNT_TYPE.BF]: 'app.distribution.pricing_policy.discount_type.bf',
    [DISCOUNT_TYPE.PERCENTAGE]:
      'app.distribution.pricing_policy.discount_type.percentage',
    [DISCOUNT_TYPE.FIXED]:
      'app.distribution.pricing_policy.discount_type.fixed',
    [DISCOUNT_TYPE.POLICY_VALUE]:
      'app.distribution.pricing_policy.discount_type.policy_value',
    [DISCOUNT_TYPE.CG1]: 'app.distribution.pricing_policy.discount_type.cg1',
  };
